import { VideoFormats, WatchVideoConditionalProps } from '../types';

function prepareDocument(document: Document, url: string, type: VideoFormats) {
  try {
    const doc = document;

    // clearing the document body inner html
    doc.body.innerHTML = '';

    document.title = 'WCG Resource';

    // custom styling  the body and video tag.
    const style = doc.createElement('style');
    style.textContent = `
    body { margin: 0; background: black; }
    video { width: 100%; height: 100%; object-fit: contain; background: black; }
  `;
    doc.head.appendChild(style);

    // Creating the video element
    const video = doc.createElement('video');
    video.controls = true;
    video.autoplay = true;

    const source = doc.createElement('source');
    source.src = url;
    source.type = type; // Adjust the type as needed
    video.appendChild(source);

    doc.body.appendChild(video);
  } catch (error) {
    console.error('Error preparing document:', error);
  }
}

function openInNewTab(url: string) {
  const newTab = window.open('', '_blank');

  if (!newTab) {
    alert('Popup blocked! Please allow popups.');
    return;
  }
  prepareDocument(newTab.document, url, 'video/mp4');
}

function openInPopup(url: string) {
  const popUpWindow = window.open(
    '',
    'VideoPopup',
    'width=1000,height=600, resizable=yes, scrollbars=no, status=yes',
  );
  if (!popUpWindow) {
    return;
  }
  prepareDocument(popUpWindow.document, url, 'video/mp4');
}

export function watchVideoLink(
  url: string,
  conditionalProps: WatchVideoConditionalProps,
) {
  if (!url.length) {
    return;
  }

  if (!conditionalProps.openTraditionalWay) {
    if (conditionalProps.openPopUp) {
      openInPopup(url);
    }
    openInNewTab(url);
  }

  window.open(url, '_blank');
}

export function downloadDocumentPdf(url: string) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = 'document.pdf'; // Suggests a filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
